import { createSlice } from "@reduxjs/toolkit";
import Auth from "../../utils/AuthUtils";

const hydrateFromSession = () => {
  return {
    user: Auth.getUserDetails() || null,
    token: Auth.getToken() || null,
    isAuthenticated: !!Auth.getToken(),
  };
};

const initialState = hydrateFromSession();

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    loginSuccess(state, action) {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
    },

    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },

    updateUser(state, action) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
});

export const { loginSuccess, logout, updateUser } = authSlice.actions;

// Returns the full user object
export const selectUser = (state) => state.auth.user;

// Returns just the user's role
export const selectUserRole = (state) => state.auth.user?.role ?? null;

// Returns the user's permissions object { dashboard: { canRead, canWrite, canDelete }, ... }
export const selectPermissions = (state) => state.auth.user?.permissions ?? {};

// Returns true if the user is logged in
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

// Returns the access token
export const selectToken = (state) => state.auth.token;

export default authSlice.reducer;
